import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { Dossier } from '@sc/data-access-models';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '../button/button.component';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'sc-adas-info-sheet',
  styleUrls: ['./adas-info-sheet.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: ` <div class="container">
    <div class="close-icon-container">
      <button (click)="onClose()">
        <sc-icon name="close"></sc-icon>
        <span class="sr_only">{{
          'GlobalApplicativeConstants.accessibility.closeDialog'
            | translate
              : {
                  dialogTitle: 'AdasInfoSheet.dialogTitle' | translate
                }
        }}</span>
      </button>
    </div>

    <h1 mat-dialog-title id="adas-info-title-id" class="sr_only">
      {{ 'AdasInfoSheet.dialogTitle' | translate }}
    </h1>

    <div class="big-icon-container">
      <span class="icon-back-circle">
        <sc-icon name="info"></sc-icon>
      </span>
    </div>
    <div class="main-infos">
      <p>{{ 'AdasInfoSheet.ruleInfo' | translate }}</p>
    </div>
    <sc-button (click)="onClose()">{{
      'AdasInfoSheet.buttonLabel' | translate
    }}</sc-button>
  </div>`,
  imports: [IconComponent, ButtonComponent, TranslateModule],
})
export class AdasInfoSheetComponent {
  @Input() dossier: Dossier;
  @Output() closeEvent = new EventEmitter<void>();

  onClose() {
    this.closeEvent.emit();
  }
}
